import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useBusiness } from '../contexts/BusinessContext';
import { useAuth } from '../contexts/AuthContext';

// Icons (replacing Material UI icons)
const AddIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
    <path fillRule="evenodd" d="M10 5a1 1 0 011 1v3h3a1 1 0 110 2h-3v3a1 1 0 11-2 0v-3H6a1 1 0 110-2h3V6a1 1 0 011-1z" clipRule="evenodd" />
  </svg>
);

const SearchIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
    <path fillRule="evenodd" d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z" clipRule="evenodd" />
  </svg>
);

const StoreIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8" viewBox="0 0 20 20" fill="currentColor">
    <path d="M3 1a1 1 0 000 2h1.22l.305 1.222a.997.997 0 00.01.042l1.358 5.43-.893.892C3.74 11.846 4.632 14 6.414 14H15a1 1 0 000-2H6.414l1-1H14a1 1 0 00.894-.553l3-6A1 1 0 0017 3H6.28l-.31-1.243A1 1 0 005 1H3zM16 16.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zM6.5 18a1.5 1.5 0 100-3 1.5 1.5 0 000 3z" />
  </svg>
);

const RestaurantIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8" viewBox="0 0 20 20" fill="currentColor">
    <path fillRule="evenodd" d="M6 3.75A2.75 2.75 0 018.75 1h2.5A2.75 2.75 0 0114 3.75v.443c.572.055 1.14.122 1.706.2C17.053 4.582 18 5.75 18 7.07v3.469c0 1.126-.694 2.191-1.83 2.54-1.952.599-4.024.921-6.17.921s-4.219-.322-6.17-.921C2.694 12.73 2 11.665 2 10.539V7.07c0-1.321.947-2.489 2.294-2.676A41.047 41.047 0 016 4.193V3.75zm6.5 0v.325a41.622 41.622 0 00-5 0V3.75c0-.69.56-1.25 1.25-1.25h2.5c.69 0 1.25.56 1.25 1.25zM10 10a1 1 0 00-1 1v.01a1 1 0 001 1h.01a1 1 0 001-1V11a1 1 0 00-1-1H10z" clipRule="evenodd" />
    <path d="M3 15.055v-.684c.126.053.255.1.39.142 2.092.642 4.313.987 6.61.987 2.297 0 4.518-.345 6.61-.987.135-.041.264-.089.39-.142v.684c0 1.347-.985 2.53-2.363 2.686a41.454 41.454 0 01-9.274 0C3.985 17.585 3 16.402 3 15.055z" />
  </svg>
);

const CafeIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8" viewBox="0 0 20 20" fill="currentColor">
    <path fillRule="evenodd" d="M4 2a2 2 0 00-2 2v11a3 3 0 106 0V4a2 2 0 00-2-2H4zm1 14a1 1 0 100-2 1 1 0 000 2zm5-1.757l4.9-4.9a2 2 0 000-2.828L13.485 5.1a2 2 0 00-2.828 0L10 5.757v8.486zM16 18H9.071l6-6H16a2 2 0 012 2v2a2 2 0 01-2 2z" clipRule="evenodd" />
  </svg>
);

const PizzaIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8" viewBox="0 0 20 20" fill="currentColor">
    <path fillRule="evenodd" d="M10 3.5a.5.5 0 01.5-.5h9a.5.5 0 01.5.5v9a.5.5 0 01-.5.5h-9a.5.5 0 01-.5-.5v-9z" clipRule="evenodd" />
    <path d="M3.5 5.5a3 3 0 116 0 3 3 0 01-6 0z" />
    <path d="M3.5 10.5a3 3 0 116 0 3 3 0 01-6 0z" />
    <path d="M3.5 15.5a3 3 0 116 0 3 3 0 01-6 0z" />
  </svg>
);

const FastfoodIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8" viewBox="0 0 20 20" fill="currentColor">
    <path d="M3 1a1 1 0 000 2h1.22l.305 1.222a.997.997 0 00.01.042l1.358 5.43-.893.892C3.74 11.846 4.632 14 6.414 14H15a1 1 0 000-2H6.414l1-1H14a1 1 0 00.894-.553l3-6A1 1 0 0017 3H6.28l-.31-1.243A1 1 0 005 1H3z" />
  </svg>
);

const BusinessesPage = ({ createMode = false }) => {
  const navigate = useNavigate();
  const { businesses, selectBusiness, loading, createBusiness } = useBusiness();
  const { isPlatformAdmin } = useAuth();
  
  const [searchTerm, setSearchTerm] = useState('');
  const [openDialog, setOpenDialog] = useState(createMode);
  const [successMessage, setSuccessMessage] = useState('');
  const [newBusiness, setNewBusiness] = useState({
    name: '',
    subdomain: '',
    type: 'restaurant',
    address: '',
    phone: '',
    email: '',
    timezone: 'America/New_York'
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [formErrors, setFormErrors] = useState({});
  
  // Handle search input change
  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };
  
  // Open create business dialog
  const handleOpenDialog = () => {
    setOpenDialog(true);
  };
  
  // Check if form has changes
  const hasFormChanges = () => {
    return newBusiness.name !== '' || 
           newBusiness.subdomain !== '' || 
           newBusiness.type !== 'restaurant' || 
           newBusiness.address !== '' || 
           newBusiness.phone !== '' || 
           newBusiness.email !== '';
  };
  
  // Close create business dialog
  const handleCloseDialog = () => {
    // Check if there are unsaved changes
    if (hasFormChanges()) {
      const confirmed = window.confirm('You have unsaved changes. Are you sure you want to close this form?');
      if (!confirmed) return;
    }
    
    // Reset form state
    setNewBusiness({
      name: '',
      subdomain: '',
      type: 'restaurant',
      address: '',
      phone: '',
      email: '',
      timezone: 'America/New_York'
    });
    setFormErrors({});
    
    // Close dialog and navigate if needed
    setOpenDialog(false);
    if (createMode) {
      navigate('/businesses');
    }
  };
  
  // Handle new business form change
  const handleNewBusinessChange = (e) => {
    const { name, value } = e.target;
    setNewBusiness(prev => ({ ...prev, [name]: value }));
    
    // Auto-generate subdomain from name if subdomain is empty
    if (name === 'name' && !newBusiness.subdomain) {
      const subdomain = value.toLowerCase().replace(/[^a-z0-9]/g, '-');
      setNewBusiness(prev => ({ ...prev, subdomain }));
    }
  };
  
  // Handle business click
  const handleBusinessClick = (businessId) => {
    selectBusiness(businessId);
    navigate(`/businesses/${businessId}`);
  };
  
  // We've already defined the success message state at the top
  
  // Validate and create a new business
  const handleCreateBusiness = async () => {
    // Clear success message
    setSuccessMessage('');
    
    // Validate required fields
    const errors = {};
    if (!newBusiness.name) errors.name = 'Business name is required';
    if (!newBusiness.subdomain) errors.subdomain = 'Subdomain is required';
    if (!newBusiness.email) errors.email = 'Email is required';
    
    // Validate subdomain format (only lowercase letters, numbers, and hyphens)
    if (newBusiness.subdomain && !/^[a-z0-9-]+$/.test(newBusiness.subdomain)) {
      errors.subdomain = 'Subdomain can only contain lowercase letters, numbers, and hyphens';
    }
    
    // Validate email format if provided
    if (newBusiness.email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(newBusiness.email)) {
      errors.email = 'Please enter a valid email address';
    }
    
    // Validate phone format if provided
    if (newBusiness.phone && !/^[\d\s\(\)\-\+]+$/.test(newBusiness.phone)) {
      errors.phone = 'Please enter a valid phone number';
    }
    
    // If we have validation errors, show them and stop
    if (Object.keys(errors).length > 0) {
      setFormErrors(errors);
      return;
    }
    
    // Clear previous errors and set submitting state
    setFormErrors({});
    setIsSubmitting(true);
    
    try {
      // Prepare the data for the API - map email to contactEmail which the API expects
      const businessData = {
        ...newBusiness,
        contactEmail: newBusiness.email,
        // Default timezone if not provided
        timezone: newBusiness.timezone || "America/New_York"
      };
      
      // Call the create business function from context
      const createdBusiness = await createBusiness(businessData);
      
      // Show success message
      setSuccessMessage(`Business "${createdBusiness.name}" created successfully!`);
      
      // Reset form
      setNewBusiness({
        name: '',
        subdomain: '',
        type: 'restaurant',
        address: '',
        phone: '',
        email: '',
        timezone: 'America/New_York'
      });
      
      // Close the dialog
      handleCloseDialog();
      
      // Navigate to the newly created business detail page
      navigate(`/businesses/${createdBusiness.id}`);
    } catch (error) {
      console.error('Failed to create business:', error);
      // Show an error message
      setFormErrors({
        submit: error.message || 'Failed to create business. Please try again.'
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  // Filter businesses based on search term
  const filteredBusinesses = businesses.filter(business => 
    business.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
    (business.type && business.type.toLowerCase().includes(searchTerm.toLowerCase())) ||
    (business.status && business.status.toLowerCase().includes(searchTerm.toLowerCase())) ||
    (business.subdomain && business.subdomain.toLowerCase().includes(searchTerm.toLowerCase()))
  );
  
  // Get icon based on business type
  const getBusinessIcon = (type = 'restaurant') => {
    switch (type) {
      case 'restaurant':
        return <RestaurantIcon />;
      case 'cafe':
        return <CafeIcon />;
      case 'pizzeria':
        return <PizzaIcon />;
      case 'fastfood':
        return <FastfoodIcon />;
      default:
        return <RestaurantIcon />;
    }
  };
  
  // Get color based on business type
  const getBusinessColor = (type = 'restaurant') => {
    switch (type) {
      case 'restaurant':
        return 'text-primary-500';
      case 'cafe':
        return 'text-accent-500';
      case 'pizzeria':
        return 'text-red-500';
      case 'fastfood':
        return 'text-yellow-500';
      default:
        return 'text-primary-500';
    }
  };
  
  return (
    <div className="w-full max-w-full">
      <div className="flex justify-between items-center mb-8 w-full">
        <h1 className="text-2xl font-bold text-white">
          Businesses
        </h1>
        
        {isPlatformAdmin && (
          <button
            className="btn-primary flex items-center space-x-2"
            onClick={handleOpenDialog}
          >
            <AddIcon />
            <span>Add Business</span>
          </button>
        )}
      </div>
      
      {/* Success message */}
      {successMessage && (
        <div className="mb-6 p-4 bg-green-800 border border-green-700 rounded-md text-green-200 flex items-center justify-between">
          <div className="flex items-center">
            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2" viewBox="0 0 20 20" fill="currentColor">
              <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
            </svg>
            <span>{successMessage}</span>
          </div>
          <button 
            onClick={() => setSuccessMessage('')}
            className="text-green-200 hover:text-white"
          >
            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
              <path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd" />
            </svg>
          </button>
        </div>
      )}

      <div className="mb-8 w-full">
        <div className="card w-full">
          <div className="p-4">
            <div className="relative w-full">
              <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none text-gray-400">
                <SearchIcon />
              </div>
              <input
                type="text"
                className="form-input pl-10 w-full"
                placeholder="Search businesses..."
                value={searchTerm}
                onChange={handleSearchChange}
              />
            </div>
          </div>
        </div>
      </div>
      
      {loading ? (
        <div className="flex justify-center py-8">
          <div className="animate-spin rounded-full h-10 w-10 border-b-2 border-primary-500"></div>
        </div>
      ) : filteredBusinesses.length === 0 ? (
        <div className="text-center py-12">
          <div className="flex justify-center mb-4">
            <StoreIcon />
          </div>
          <h2 className="text-xl font-semibold mb-2">
            No businesses found
          </h2>
          {searchTerm ? (
            <p className="text-gray-400">
              No businesses match your search. Try a different term.
            </p>
          ) : (
            <p className="text-gray-400">
              No businesses have been added yet.
            </p>
          )}
          {isPlatformAdmin && (
            <button
              className="btn-primary flex items-center space-x-2 mx-auto mt-4"
              onClick={handleOpenDialog}
            >
              <AddIcon />
              <span>Add Your First Business</span>
            </button>
          )}
        </div>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 w-full">
          {/* Render actual businesses */}
          {filteredBusinesses.map(business => (
            <div key={business.id} className="cursor-pointer w-full" onClick={() => handleBusinessClick(business.id)}>
              <div 
                className="card hover:shadow-glow transition-all duration-200 transform hover:-translate-y-1 w-full"
              >
                <div className="p-4">
                  <div className="flex justify-between mb-4">
                    <div className={getBusinessColor(business.type)}>
                      {getBusinessIcon(business.type)}
                    </div>
                    <span 
                      className={`px-2 py-1 text-xs font-medium rounded-full ${
                        business.status === 'active' 
                          ? 'bg-green-900 text-green-300' 
                          : 'bg-gray-700 text-gray-300'
                      }`}
                    >
                      {business.status === 'active' ? 'Active' : 'Inactive'}
                    </span>
                  </div>
                  
                  <h3 className="text-lg font-semibold mb-1">
                    {business.name}
                  </h3>
                  
                  <p className="text-gray-400 capitalize mb-4">
                    {business.type || 'restaurant'}
                  </p>
                  
                  <div className="grid grid-cols-3 gap-2">
                    <div>
                      <p className="text-xs text-gray-500">
                        Locations
                      </p>
                      <p className="text-sm">
                        {business.locations || 1}
                      </p>
                    </div>
                    <div>
                      <p className="text-xs text-gray-500">
                        Orders
                      </p>
                      <p className="text-sm">
                        {business.orders || 0}
                      </p>
                    </div>
                    <div>
                      <p className="text-xs text-gray-500">
                        Subdomain
                      </p>
                      <p className="text-xs break-all">
                        {business.subdomain || business.name.toLowerCase().replace(/\s+/g, '-')}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
      
      {/* Create Business Dialog */}
      {openDialog && (
        <div className="fixed inset-0 flex items-center justify-center z-50">
          <div className="fixed inset-0 bg-black bg-opacity-50" onClick={handleCloseDialog}></div>
          <div className="bg-dark-700 rounded-lg shadow-xl w-full max-w-md mx-4 z-50 border border-dark-600">
            <div className="p-6">
              <h2 className="text-xl font-semibold mb-4">Create New Business</h2>
              
              <div className="space-y-4">
                <div>
                  <label className="form-label" htmlFor="business-name">Business Name</label>
                  <input
                    id="business-name"
                    type="text"
                    className={`form-input ${formErrors.name ? 'border-red-500' : ''}`}
                    name="name"
                    value={newBusiness.name}
                    onChange={handleNewBusinessChange}
                    required
                  />
                  {formErrors.name && (
                    <p className="text-red-500 text-xs mt-1">{formErrors.name}</p>
                  )}
                </div>
                
                <div>
                  <label className="form-label" htmlFor="subdomain">Subdomain</label>
                  <input
                    id="subdomain"
                    type="text"
                    className={`form-input ${formErrors.subdomain ? 'border-red-500' : ''}`}
                    name="subdomain"
                    value={newBusiness.subdomain}
                    onChange={handleNewBusinessChange}
                    required
                  />
                  <p className="text-xs text-gray-400 mt-1">
                    This will be the URL: {newBusiness.subdomain || 'your-business'}.virtual-menu.ai
                  </p>
                  {formErrors.subdomain && (
                    <p className="text-red-500 text-xs mt-1">{formErrors.subdomain}</p>
                  )}
                </div>
                
                <div>
                  <label className="form-label" htmlFor="business-type">Business Type</label>
                  <select
                    id="business-type"
                    className="form-input"
                    name="type"
                    value={newBusiness.type}
                    onChange={handleNewBusinessChange}
                  >
                    <option value="restaurant">Restaurant</option>
                    <option value="cafe">Cafe</option>
                    <option value="pizzeria">Pizzeria</option>
                    <option value="fastfood">Fast Food</option>
                    <option value="other">Other</option>
                  </select>
                </div>
                
                <div>
                  <label className="form-label" htmlFor="address">Address</label>
                  <input
                    id="address"
                    type="text"
                    className="form-input"
                    name="address"
                    value={newBusiness.address}
                    onChange={handleNewBusinessChange}
                  />
                </div>
                
                <div>
                  <label className="form-label" htmlFor="phone">Phone Number</label>
                  <input
                    id="phone"
                    type="text"
                    className={`form-input ${formErrors.phone ? 'border-red-500' : ''}`}
                    name="phone"
                    value={newBusiness.phone}
                    onChange={handleNewBusinessChange}
                    placeholder="e.g. (123) 456-7890"
                  />
                  {formErrors.phone && (
                    <p className="text-red-500 text-xs mt-1">{formErrors.phone}</p>
                  )}
                </div>
                
                <div>
                  <label className="form-label" htmlFor="email">Email</label>
                  <input
                    id="email"
                    type="email"
                    className={`form-input ${formErrors.email ? 'border-red-500' : ''}`}
                    name="email"
                    value={newBusiness.email}
                    onChange={handleNewBusinessChange}
                    placeholder="e.g. contact@yourbusiness.com"
                  />
                  {formErrors.email && (
                    <p className="text-red-500 text-xs mt-1">{formErrors.email}</p>
                  )}
                </div>
                
                <div>
                  <label className="form-label" htmlFor="timezone">Timezone</label>
                  <select
                    id="timezone"
                    className="form-input"
                    name="timezone"
                    value={newBusiness.timezone}
                    onChange={handleNewBusinessChange}
                  >
                    <option value="America/New_York">Eastern Time (ET)</option>
                    <option value="America/Chicago">Central Time (CT)</option>
                    <option value="America/Denver">Mountain Time (MT)</option>
                    <option value="America/Los_Angeles">Pacific Time (PT)</option>
                    <option value="America/Anchorage">Alaska Time (AK)</option>
                    <option value="Pacific/Honolulu">Hawaii Time (HI)</option>
                  </select>
                </div>
              </div>
              
              {formErrors.submit && (
                <div className="mt-4 p-2 bg-red-900 text-red-200 rounded-md text-sm">
                  {formErrors.submit}
                </div>
              )}
              
              <div className="flex justify-end mt-6 space-x-2">
                <button 
                  className="btn-secondary"
                  onClick={handleCloseDialog}
                >
                  Cancel
                </button>
                <button 
                  className={`btn-primary ${isSubmitting ? 'opacity-50 cursor-not-allowed' : ''}`}
                  onClick={handleCreateBusiness}
                  disabled={isSubmitting}
                >
                  {isSubmitting ? 'Creating...' : 'Create Business'}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default BusinessesPage;